import "../style.css";
import AdminInput from "../../components/AdminInput";
import { useTranslation } from "react-i18next";

const PaymentMethod = ({
    loading,
    data,
    iataEligible,
    setIataEligible,
    iataDiscount,
    setIataDiscount,
    deferredPaymentEligible,
    setDeferredPaymentEligible,
    onUpdate,
    canUpdate = false,
    updateDisabledReason = "",
}) => {
    const { t } = useTranslation();

    return (
        <div className="card-body px-4">
            <h5 className="account-section-title py-2">Payment Method</h5>
            <hr className="hr-grey-account" />
            <div className="row d-flex align-items-start justify-content-between">
                <div className="col-12 col-lg-10">
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-12 col-lg-3 mb-2 mb-lg-0">
                            <p className="account-text-label mb-0">
                                Payment Method
                            </p>
                        </div>
                        <div className="col-12 col-lg-9">
                            <p className="account-text-value mb-0">
                                Credit Card
                            </p>
                        </div>
                    </div>
                </div>
                {
                    false && (
                        <div className="col-12 col-lg-2 d-flex align-items-start justify-content-end">
                            <button
                                type="button"
                                className="btn btn-edit-account px-2 py-2 mt-2 mt-lg-0"
                                onClick={() => { }}
                            >
                                {t("myPage.accountInformation.subMenu.paymentMethod.button")}
                            </button>
                        </div>
                    )
                }
            </div>
            <hr className="hr-grey-account" />
            <div className="row d-flex align-items-start justify-content-between">
                <div className="col-12 col-lg-10">
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-12 col-lg-3 mb-2 mb-lg-0">
                            <p className="account-text-label mb-0">
                                Payment Type
                            </p>
                        </div>
                        <div className="col-auto mb-3 mb-lg-0 d-flex justify-content-start align-items-center gap-2">
                            <div
                                className={`iata-radio-box${!deferredPaymentEligible ? '-check' : ""} d-flex justify-content-start align-items-center gap-2 pointer`}
                                onClick={() => setDeferredPaymentEligible(false)}
                            >
                                <input
                                    className="iata-check-input"
                                    type="radio"
                                    name="deferredPaymentEligible"
                                    id="deferredPaymentEligible"
                                    onChange={() => setDeferredPaymentEligible(false)}
                                    checked={!deferredPaymentEligible}
                                />
                                <p className='account-text-value mb-0 pe-3'>{"Advance Payment・前払い"}</p>
                            </div>
                            <div
                                className={`iata-radio-box${deferredPaymentEligible ? '-check' : ""} d-flex justify-content-start align-items-center gap-2 pointer`}
                                onClick={() => setDeferredPaymentEligible(true)}
                            >
                                <input
                                    className="iata-check-input"
                                    type="radio"
                                    name="deferredPaymentEligible"
                                    id="deferredPaymentEligible"
                                    onChange={() => setDeferredPaymentEligible(true)}
                                    checked={deferredPaymentEligible}
                                />
                                <p className='account-text-value mb-0 pe-3'>{"Deferred Payment・後払い"}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="hr-grey-account" />
            <div className="row d-flex align-items-start justify-content-between">
                <div className="col-12 col-lg-10">
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-12 col-lg-3 mb-2 mb-lg-0">
                            <p className="account-text-label mb-0">
                                Discount
                            </p>
                        </div>
                        <div className="col-auto mb-3 mb-lg-0 d-flex justify-content-start align-items-center gap-2">
                            <div
                                className={`iata-radio-box${iataEligible ? '-check' : ""} d-flex justify-content-start align-items-center gap-2 pointer`}
                                onClick={() => setIataEligible(true)}
                            >
                                <input
                                    className="iata-check-input"
                                    type="radio"
                                    name="iataDiscount"
                                    id="iataDiscount"
                                    onChange={() => setIataEligible(true)}
                                    checked={iataEligible}
                                />
                                <p className='account-text-value mb-0 pe-3'>{"Eligible"}</p>
                            </div>
                            <div
                                className={`iata-radio-box${!iataEligible ? '-check' : ""} d-flex justify-content-start align-items-center gap-2 pointer`}
                                onClick={() => setIataEligible(false)}
                            >
                                <input
                                    className="iata-check-input"
                                    type="radio"
                                    name="iataDiscount"
                                    id="iataDiscount"
                                    onChange={() => setIataEligible(false)}
                                    checked={!iataEligible}
                                />
                                <p className='account-text-value mb-0 pe-3'>{"Not Eligible"}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                iataEligible && (
                    <div className="row d-flex align-items-start justify-content-between">
                        <div className="col-12 col-lg-10">
                            <div className="row d-flex align-items-start justify-content-start mb-3">
                                <div className="col-12 col-lg-3 mb-2 mb-lg-0">
                                    <p className="account-text-label mb-0">
                                        Discount Rate (%)
                                    </p>
                                </div>
                                <div className="col-auto mb-3 mb-lg-0">
                                    <AdminInput
                                        type={"number"}
                                        suffixClass={"mb-0 fs-14"}
                                        placeholder={"rate"}
                                        id={"iataDiscount"}
                                        name={"iataDiscount"}
                                        value={iataDiscount}
                                        onChange={(e) => setIataDiscount(e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                onUpdate && (
                    <div className="row d-flex align-items-center justify-content-end mt-2">
                        <div className="col-auto d-flex align-items-center justify-content-end">
                            <button
                                type="button"
                                className="btn btn-update-payment"
                                onClick={onUpdate}
                                disabled={loading || !canUpdate}
                                title={!canUpdate ? updateDisabledReason : ""}
                            >
                                Update Payment Setting
                            </button>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default PaymentMethod;
